module.exports = __webpack_public_path__ + "assets/img/jyrw2.d740f8db.jpg";